import React, {Component, Fragment } from 'react';
import axios from 'axios'

import withStyles from '@mui/styles/withStyles';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Autocomplete from '@mui/material/Autocomplete';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';

import styles from "../styles";
import PageHeader from "../helper/PageHeader";
import Loading from '../helper/Loading';
import Error from '../helper/Error';
import SortedTable from '../helper/SortedTable';
import DeleteDialog from '../helper/Dialogs';
import { authContext } from "../../context/AuthContext";

class WorkshopOrganizations extends Component {
    static contextType = authContext;

    constructor(props) {
        super(props);

        this.categoryMap = new Map();
        this.categoryCodeMap = new Map();
        this.categories = [];
        this.categoriesLoaded = false;


        this.state = {
            organizations: [],
            error: null,
            modalIsOpen: false,
            modalMode: '',
            id: null,
            organizationName: '',
            organizationCode: '',
            category: '',
            searchCategory: null, //'',
            searchName: '',
            isLoading: true,
            isDeleteDialogOpen: false,
            itemToDelete: ''
        }
    }

    handleDeleteDialogOpen = () => {
        this.setState({ isDeleteDialogOpen: true });
    };

    handleDeleteDialogClose = () => {
        this.setState({ isDeleteDialogOpen: false });
    };

    onNew = (event) => {
        this.props.history.push('/administration/workshopOrganization');
    }

    onEdit = (tag) => {
        let id = tag;
        this.props.history.push('/administration/workshopOrganization/' + id);
    }

    hideError = () => {
        this.setState({ error: '' })
    }

    handleChange = event => {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    onCategoryChange = (selected) => {
        this.setState({ category: JSON.parse(JSON.stringify(selected)) });
    }

    validate = (event) => {
        if (this.formLoc.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
            this.formLoc.classList.add('was-validated');

            return false;
        } else {
            this.formLoc.classList.add('was-validated');
            return true;
        }
    }

    openDeleteDialog = (tag) => {
        this.setState({ itemToDelete: tag });
        this.handleDeleteDialogOpen();
    }

    onDelete = (tag) => {
        this.handleDeleteDialogClose();
        let token = sessionStorage.getItem('accessToken');
        let id = this.state.itemToDelete;

        this.setState({ itemToDelete: '' });
        let url = "/api/organization/" + id;

        axios(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then(response => {
            if (response.status >= 400) {
                throw new Error(response.statusText);
            }
            this.refresh();
        }).catch(err => {
            this.setState({ error: err.message });
            console.log(this.error);
        });
    }

    onSearchCategoryChange = (name, value) => {
        // let selected = value;
        // if (selected === null) {
        //     this.setState({
        //         searchCategory: ''
        //     })
        //     return;
        // }

        // this.setState({ searchCategory: JSON.parse(JSON.stringify(selected)) });
        this.setState({ searchCategory: value });

    }

    onSearch = (event) => {
        event.preventDefault();
        console.log("searching...")
        this.refresh();
    }

    refresh() {
        // console.log(this.state.searchCategory.value);
        axios.get('/api/organization/search', {
            params: {
                name: this.state.searchName,
                category: this.state.searchCategory ? this.state.searchCategory.value : null,
            }
        }).then((res) => {
            this.setState({
                organizations: res.data.organizations,
                isLoading: false
            })
        }).catch(error => {
            console.log("error:" + error);
            this.setState({
                isLoading: false,
                error: error.message
            });
        });
    }


    componentDidMount() {
        axios.get('/api/category', {
        }).then((res) => {
            res.data.categories.forEach((u) => {
                this.categoryMap[u.ID] = u.categoryName;
                this.categoryCodeMap[u.ID] = u.categoryCode;
                this.categories.push({ label: u.categoryName, value: u.ID });
            });
            this.categoriesLoaded = true;
            this.refresh();
        }).catch(error => {
            console.log("error:" + error);
            this.setState({
                error: error.message
            });
        });

    }

    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state,callback)=>{
            return;
        };
    }

    render() {
        const { classes } = this.props;
        const enableActions = this.context.roles.isClassroomTrainingAdmin === 1? true:false;

        if (this.state.error) {
            return <div>
                <br />
                <Alert severity="error" onClose={this.hideError}>{this.state.error}</Alert>
                <br />
            </div>
        }

        if (this.state.isLoading || !this.categoriesLoaded) {
            return <Loading />;
        }

        let enhancedData = [];
        enhancedData = this.state.organizations.map((organization) => {
            let org = JSON.parse(JSON.stringify(organization))
            org.organizationCode = (this.categoryCodeMap[org.categoryId] || "") + org.organizationCode;
            org.categoryName = this.categoryMap[org.categoryId] || "-";
            return org;
        });

        const headCells = enableActions ? [
            { id: 'actions', centered: false, sortable: false, label: 'Actions' },
            { id: 'organizationName', centered: false, sortable: true, label: 'Name' },
            { id: 'organizationCode', centered: true, sortable: true, label: 'Code' },
            { id: 'categoryName', centered: true, sortable: true, label: 'Category' },
        ] : [
            { id: 'organizationName', centered: false, sortable: true, label: 'Name' },
            { id: 'organizationCode', centered: true, sortable: true, label: 'Code' },
            { id: 'categoryName', centered: true, sortable: true, label: 'Category' },
        ];

        const bodyCells = [
            { name: 'organizationName', centered: false },
            { name: 'organizationCode', centered: true },
            { name: 'categoryName', centered: true },
        ];

        const defaultSortKey = 'organizationName';

        return (
            <Fragment>
                <PageHeader
                    title={"Training Provider Organizations"}
                    actionButtons={[{ label: "Add new organization", action: this.onNew, disabled: enableActions === false }]}
                />

                <div>
                    <form className={classes.root} onSubmit={this.onSearch}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    label="Organization Name"
                                    type="text"
                                    name='searchName'
                                    value={this.state.searchName}
                                    className={[classes.textField].join(' ')}
                                    onChange={this.handleChange}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Autocomplete
                                    options={this.categories}
                                    getOptionLabel={(option) => option.label}
                                    isOptionEqualToValue={(option, val) => option.value===val.value}
                                    value={this.state.searchCategory}
                                    onChange={this.onSearchCategoryChange}
                                    className={[classes.autoComplete].join(' ')}
                                    renderInput={(params) => <TextField {...params} label="Category" />}
                                />
                            </Grid>
                            <Grid item xs={12} style={{ textAlign: "center", alignSelf: "flex-end" }}>
                                <Button variant="contained" color="primary" type="submit" className={[].join(' ')} >Search</Button>
                            </Grid>
                        </Grid>
                        <br /><br />

                        {this.state.organizations.length === 0
                            ?
                            <Box display="flex" mt={4} justifyContent="center">
                                <h1>No Data</h1>
                            </Box>
                            :
                            <SortedTable
                                data={enhancedData}
                                headCells={headCells}
                                bodyCells={bodyCells}
                                defaultSortKey={defaultSortKey}
                                cellKey={"ID"}
                                editDelete={enableActions}
                                edit={this.onEdit}
                                delete={this.openDeleteDialog}
                            />
                        }

                        <DeleteDialog
                            open={this.state.isDeleteDialogOpen}
                            onClose={this.handleDeleteDialogClose}
                            onDelete={this.onDelete}
                        />
                    </form>
                </div>
            </Fragment>
        );
    }
}

// export default WorkshopOrganizations;
export default withStyles(styles, { withTheme: true })(WorkshopOrganizations);
